<template>
    <div class="row">
        <div class="col-md-12">
            <el-upload accept=".pdf,.png,.jpg,.jpeg,.docx,.doc,.txt,.msg" :before-upload="handleBeforeUpload" drag :action="URL" :data="options" :on-preview="handlePreview"
            :on-remove="handleRemove" :show-file-list="module != 'transactionComplete'" :on-success="handleSuccess" v-bind:on-progress="onProgress" :file-list="files">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                <div class="el-upload__tip" slot="tip">*.pdf/.png/.jpg/.jpeg/.docx/.doc/.txt/.msg Document files with a size less than 10MB</div>
            </el-upload>
        </div>
    </div>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import { Upload } from "element-ui";
import Util from "@/util/util";


export default {
    name: "alert-signature-upload",
    components: {
        [Upload.name]: Upload,
    },
    props: ['fileTypeId', 'module'],
    mixins: [Utility],
    data() {
        return {
            files: [],
            error: false,
        }
    },
    computed: {
        options() {
            let orderId = this.$route.params.id;

            return { orderId: orderId, fileTypeId: this.fileTypeId }
        },
        URL() {
            if(!this.error){
                return `${window.location.protocol}//${window.location.host}${process.env.BASE_URL}api/orderfiles/signature`;
            }
          
        }
    },
    methods: {
        load() {
            //get files
                this.getFiles()
        },
        getFiles() {
            let orderId = this.$route.params.id;
            this.axios.get(`api/orderfiles/order/${orderId}/type/${this.fileTypeId}`).then((response) => {
                //Load the data

                this.files = response.data;
            }).catch((err) => {
                this.$toast.error("Error on generating the signature, Please try again later");
            });
        },
        handlePreview() { },
        onProgress() {
            this.$loaderApp.addRequest();
        },
        handleSuccess() {
            this.$emit('onUploadResult');
            this.$loaderApp.completeRequest();
        },
        handleBeforeUpload(file){
            if (!Util.isSupportedFile(file.name, /(\.pdf|\.png|\.jpg|\.jpeg|\.docx|\.doc|\.txt|\.msg)$/i) || file.size > 10485760  ) {
        this.$toast.error("Invalid File!");
          this.error = true
          this.$emit('isError', true)
          return false
      } 
        },
        handleRemove(file) {
            this.$loaderApp.addRequest();
            this.axios.delete(`api/orderfiles/archive/${file.id}`).then((response) => {
                //Load the data
                this.getFiles();
                 this.$loaderApp.completeRequest();
            }).catch((err) => {
                 this.$loaderApp.completeRequest();
                this.$toast.error("Error on generating the signature, Please try again later");
            });
        }
    }
}
</script>

<style scopped>
.el-upload,
.el-upload-dragger {
    width: 100%;
}
</style>
